import EmployeeBlogList from './employeeblogsList';

import Usegetemployeeblogs from '../hooks/usegetemployeeblogdata';

const DeletedBlogStories = ({ searchText, filterYear }) => {
  const employeeBlogData = Usegetemployeeblogs({
    BlogId: '',
    isDeleted: 'True',
    searchText: searchText,
    filterYear: filterYear,
  });

  return (
    <>
      {employeeBlogData?.data?.data.length === 0 ? (
        <div className='bg-[#fff] min-h-[72vh] mt-4 rounded-2xl shadow-2xl flex flex-col justify-center items-center'>
          <p className='my-2 text-[#808080]'>You have no deleted Stories. </p>
          <p className='text-[#808080]'>
            Write a <span className='text-[#67A1EF]'>story</span> or
            <span className='text-[#67A1EF]'>&nbsp;read</span> other articles
          </p>
        </div>
      ) : (
        <div className='bg-[#fff] min-h-[72vh] rounded-xl shadow-2xl p-5 w-full'>
          <div className=''>
            {employeeBlogData?.data?.data.map((eachBlog) => (
              <div className='' key={eachBlog.id}>
                <EmployeeBlogList blogData={eachBlog} name={'Delete'} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default DeletedBlogStories;
